export default __webpack_public_path__ + "static/media/EM1090.34I-27920_-16747_0.ac9f00f0.jpg";